import { clearClientAuthorization, configureClient } from '@portal/rocket-api-client';
import axios from 'axios';

import { API_URL } from '../constants';
import { getToken } from '../utils/token';

export const AxiosService = axios.create({
  baseURL: `${API_URL}/v1/`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const AxiosBaseService = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const AxiosFileService = axios.create({
  baseURL: `${API_URL}/v1/`,
  headers: {
    Accept: 'application/gzip',
  },
});

/**
 * Creates an Axios instance with no Authorization header
 * TODO:
 * Add an optional argument to disable authentication in the generated hooks,
 * replace the usage of this function with that argument,
 * and remove this function.
 */
export const createUnauthenticatedInstance = () => {
  const instance = axios.create({ baseURL: `${API_URL}/v1/` });
  instance.defaults.headers.common = {};
  return instance;
};

const AxiosInternalService = axios.create({
  baseURL: `${API_URL}/internal/v1/`,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Updates Authorization header Bearer token
 * @param token The JWT base64 value
 */

const qsParams = new URLSearchParams(window.location.search);

let jwt = getToken();
const qsToken = qsParams.get('token');

if (typeof qsToken === 'string') {
  jwt = qsToken;
}

export function setAuthorizationHeaders(jwt: string) {
  AxiosService.defaults.headers.common.Authorization = `Bearer ${jwt as string}`;
  AxiosBaseService.defaults.headers.common.Authorization = `Bearer ${jwt as string}`;
  AxiosFileService.defaults.headers.common.Authorization = `Bearer ${jwt as string}`;
  AxiosInternalService.defaults.headers.common.Authorization = `Bearer ${jwt as string}`;
  configureClient({ baseURL: API_URL, token: jwt });
}

export function clearAuthorizationHeaders() {
  AxiosService.defaults.headers.common.Authorization = false;
  AxiosBaseService.defaults.headers.common.Authorization = false;
  AxiosFileService.defaults.headers.common.Authorization = false;
  AxiosInternalService.defaults.headers.common.Authorization = false;
  clearClientAuthorization();
}

setAuthorizationHeaders(jwt as string);
